"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
export default function Cart() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: blockRef,
    isVisible: blockVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  return <section data-section-id="20013" id="cart-content" className="bg-background py-24 md:py-32">
      <div className="mx-auto w-full max-w-[1120px] px-[clamp(1rem,5vw,1.5rem)] md:px-[clamp(1.25rem,4vw,2.5rem)]">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-7 items-end transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {}
          <div className="md:col-span-8">
            <div className="text-xs font-medium uppercase font-default text-muted-foreground" style={{
            letterSpacing: "0.18em",
            lineHeight: 1
          }}>
              Your curated selection
            </div>

            {}
            <div className="mt-5 h-px w-14 bg-border" />

            {}
            <h2 className="mt-6 font-default font-normal text-foreground" style={{
            fontFamily: "var(--font-serif)",
            fontSize: "clamp(2rem, 3.6vw, 3.5rem)",
            letterSpacing: "-0.015em",
            lineHeight: 1.06
          }}>
              Flavors{" "}
              <span className="relative inline-block">
                <em className="italic" style={{
                fontFamily: "var(--font-serif)",
                fontStyle: "italic"
              }}>
                  awaiting
                </em>
                <span className={`absolute left-0 -bottom-1 h-[1px] bg-primary transition-all ease-out ${headerVisible ? "w-full" : "w-0"}`} style={{
                transitionDuration: "360ms",
                transitionDelay: "300ms"
              }} />
              </span>{" "}
              your arrival.
            </h2>
          </div>

          {}
          <div className="md:col-span-4 md:flex md:justify-end md:items-end md:pb-2">
            <Link to="/ShopPage" className="group inline-flex items-center gap-3 font-default font-medium text-foreground hover:text-primary transition-colors duration-200" style={{
            fontSize: "0.9375rem"
          }}>
              <span>Continue exploring</span>
              <ArrowRight className="size-3 transition-transform duration-200 ease-out group-hover:translate-x-1" strokeWidth={1.25} />
            </Link>
          </div>
        </div>

        {}
        <div className="mt-10 md:mt-14 h-px w-full bg-border" />

        {}
        <div ref={blockRef} className={`mt-10 md:mt-14 w-full transition-all duration-700 ease-out font-default text-foreground ${blockVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <WooCommerceCartBlock />
        </div>
      </div>
    </section>;
}